import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import useBodyClass from "../../common/hooks/useBodyClassName";
import arrowInCircle from '../../images/newDesign/arrow_in_white_circle.svg';
import Button from '../../common/Button';
import { constants } from "../../common/constants/constants";
import PaymentFlowContainer from "./PaymentFlowContainer";
import { BankInfoStyled } from "./BankInfo.styled";

export function BankInfo({ match, address }) {
    const { t } = useTranslation();
    const { buildingID } = match.params;
    const history = useHistory();

    const ltr = useSelector(state => state.common.ltrEnabled);

    useBodyClass(['payment-flow', 'info-bank-page']);

    const closeInfo = () => history.goBack();

    const continueToDetails = () => history.push({ pathname: `/${constants.pages.tenantDetailsUrl}-new/${buildingID}` });

    return (
        <PaymentFlowContainer title={t('payments.paymentThroughBank')} hideLogo hideSubheader>
            <span className='close-btn cross' onClick={closeInfo}>&#215;</span>
           <BankInfoStyled ltr={ltr}>
                <div className="text-block">
                    <div className="block-header">{t('payments.howToMakePayment')}</div>
                    <ul>
                        <li>{t('payments.directTransfer')}</li>
                        <li>{t('payments.digitalAuth')}</li>
                    </ul>                  
                </div>

                <div className="text-block">
                    <div className="block-header">{t('payments.directTransfer')}</div>
                    <ul>
                        <li>{t('payments.fillDetailsForTransfer')}</li>
                        <li>{t('payments.confirmationOrPending')}</li>
                    </ul>
                </div>

                <div className="text-block">
                    <div className="block-header">{t('payments.establishingAuth')}</div>
                    <ul>
                        <li>{t('payments.fastSignProcess')}</li>
                        <li>{t('payments.tenDaysToVerify')}</li>
                    </ul>
                </div>

                <div className='btn-wrapper'>
                    <Button type="submit" onClick={continueToDetails}>
                        {t('expenses.set_expenses.continue')} 
                        <img className='arrow' src={arrowInCircle} />
                    </Button>
                </div>
            </BankInfoStyled> 
        </PaymentFlowContainer>
    )
}
